module.exports = __webpack_public_path__ + "img/hero-mobile.91edb088.png";